(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement-bar__grid').forEach(function (grid) {
      var items = grid.querySelectorAll('.announcement-bar__item');
      if (items.length < 2) return;

      var mqMobile = window.matchMedia('(max-width: 520px)');
      var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var i = 0, timer = null;

      function show(n) {
        items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === n); });
      }
      function start() {
        if (timer) return;
        grid.classList.add('js-rotate');
        var primary = grid.querySelector('.announcement-bar__item.is-mobile-primary');
        i = primary ? Array.prototype.indexOf.call(items, primary) : 0;
        show(i);
        timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, 4500);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        grid.classList.remove('js-rotate');
        items.forEach(function (el) { el.classList.remove('is-active'); });
      }
      function update() { (mqMobile.matches && !mqReduce.matches) ? start() : stop(); }

      update();
      mqMobile.addEventListener('change', update);
      mqReduce.addEventListener('change', update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
